import { useState } from 'react';
import apiService from '../../axios/apiService';
import { useLocation } from 'react-router-dom';
import { getSearchParamFromLocation } from '../../utils/mapper';
import { message } from 'antd';

export const useInvoiceServiceRestore = () => {
  const [loading, setLoading] = useState(false);
  const [recordId, setRecordId] = useState(undefined);
  const location = useLocation();

  const restoreInvoiceService = async (invoiceServiceId) => {
    // Restore invoice service
    setLoading(true);
    setRecordId(invoiceServiceId);
    try {
      const invoiceId = getSearchParamFromLocation('id', location);
      if (!invoiceId || !invoiceServiceId) {
        return message.error('Please provide invoice ID');
      }
      const response = await apiService.restoreInvoiceService(invoiceId, invoiceServiceId);
      return response;
    } finally {
      setLoading(false);
      setRecordId(undefined);
    }
  };

  return {
    loading,
    recordId,
    restoreInvoiceService
  };
};
